require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-spring-dev-accelerators-kick-off-day.json") })
        }
      }, "path---blog-spring-dev-accelerators-kick-off-day");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-spring-dev-accelerators-kick-off-day!./.cache/json/blog-spring-dev-accelerators-kick-off-day.json
// module id = 1076
// module chunks = 231608221292675